export default {
  title: "Users",
  total: "Total:",

  admin: "Administrator",
  controlAccess: "Management",

  writeAccess: "Editing access",
  readAccess: "Read only access",
  adminAccess: "Administrator",

  addUserBtn: "Add a user",
  manageUsersBtn: "Manage users",
  lookUsersBtn: "Look users",
  notification:
    "Add a user to your personal account (a colleague or a representative of the developer)",
  pluralize: ["user", "users"],

  modal: {
    addUserBtn: "Add user",
    addUserTitle: "Add user",
    userAccessFieldTitle: "Access",
    userAccessRead: "Read only",
    userAccessWrite: "Editing",
    adminAccessWrite: "Administrator",
    installer: "Installer",
    edit: "Reading and editing",
    read: "Only reading",
    addHelpMessage:
      "An e-mail will be sent to the indicated e-mail address allowing you<br> to activate all the features of your personal account.",

    submitBtn: "Submit",
    submittingBtn: "Submitting...",

    removeAllBtn: "Delete all",
    removeAllMessage:
      "Are you sure you want to delete all users except administrators?",

    admin: "Administrator",
    notActivated: "Account isn't activated",

    inviteAlreadyExistsError: "Invite already created for this e-mail",
    userFromDifferentCompanyError: "User is associated with another company",
    unknownError: "Unknown error",

    inviteResentSuccessMessage: "Invite was successfully resent",
    inviteResentErrorMessage: "An error occured while resending the invite",
    inviteResentTimeoutErrorMessage:
      "Invite has already been sent to the specified e-mail. If the e-mail is not delivered, you should wait for about 5 minutes and try again.",

    accessUpdateSuccess: "User access level has been successfully updated",
    accessUpdateFail: "There was an error while updating user access level",

    addUserSuccessMessage: "Invite has been sent",
    adminRoleDescription:
      "Option to make changes to your Personal Account details, edit, add and delete users, issue passes and service orders.",
    editRoleDescription:
      "Option to make changes to your Personal Account details, issue passes and service orders.",
    readRoleDescription: "Viewing information in your Personal Account.",
    installRoleDescription:
      "Contractor’s representative, option to place orders for services"
  }
};
